export const LOADING_OBJECTIVE_VALUE = "LOADING_OBJECTIVE_VALUE";
export const SAVE_LOADING_OBJECTIVE_VALUE = "SAVE_LOADING_OBJECTIVE_VALUE";
export const GET_OBJECTIVE_VALUE = "GET_OBJECTIVE_VALUE";
export const FORM_FAIL = "FORM_FAIL";
export const OBJECTIVE_VALUE_FAIL = "OBJECTIVE_VALUE_FAIL";
export const LOADING_OBJECTIVE_VALUE_BY_ID = "LOADING_OBJECTIVE_VALUE_BY_ID";
export const GET_OBJECTIVE_VALUE_BY_ID = "GET_OBJECTIVE_VALUE_BY_ID";

